import React from "react";

/** 3rd party components -------------------------------------- */
import RSlider from "react-rangeslider";

/** Aux components -------------------------------------------- */
import ASSET_CLASSES from "../../asset-classes";
import DEFAULT_ALLOCATIONS from "../../default-allocations";

/**
 * Slider to choose the desired allocation between
 * the available asset classes
 *
 * @param {number} min the minimum allocation value
 * @param {number} max the maximum allocation value
 * @param {string} color the color of the slider
 * @param {string} label the slider label to display the name
 * of the asset class being allocatated.
 *
 * @author Giovanna Marinelli
 */
const Slider = ({ min, max, value, color = "black", label, onChange }) => {
  return (
    <div className={`RangeSlider RangeSlider--${color}`}>
      <div className="RangeSlider__label-container">
        <div className="RangeSlider__label-text">{label || ""}</div>
        <div className="RangeSlider__label-value">
          {value !== null || value !== undefined ? value.toFixed(1) + "%" : ""}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <RSlider
            step={1}
            min={min}
            max={max}
            value={value}
            orientation="horizontal"
            onMouseUp={onChange}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};

/**
 * Display the profile builder section, which contains the sliders
 * to the user choose between the available asset classes to
 * run the simualtion
 *
 * @author Giovanna Marinelli
 */
const ProfileBuilder = ({ allocation = DEFAULT_ALLOCATIONS["Agressiva"], onAllocationChange }) => {

  /**
   *
   * @param {string} name The name of the asset class
   * @param {string} span The alt name of the asset class
   */
  const createLabel = (name, altName) => {
    return (
      <div>
        {`${name} `}
        {altName ? (
          <span style={{ fontSize: "0.7rem" }}>{`(${altName})`}</span>
        ) : null}
      </div>
    );
  };

  /**
   * Change the allocation value on an asset class
   * @param {string} assetClass 
   * @param {number} value 
   */
  const handleAllocationChange = (assetClass, value) => {
    const newAllocation = { ...allocation };
    newAllocation[assetClass] = value;
    onAllocationChange && onAllocationChange(newAllocation);
  };

  /**
   * Display the list of sliders with all the available classes.
   */
  const renderSliders = () => {
    const assetNotPandhora = Object.assign({}, ASSET_CLASSES);
    const essencial = 'pandhoraEssencial';
    const lb = "pandhoraLb";

    delete assetNotPandhora[essencial];
    delete assetNotPandhora[lb];
    return Object.keys(assetNotPandhora).map((key) => {
      const assetClass = assetNotPandhora[key];
      return (
        <div key={key} style={{ paddingTop: "15px" }}>
          <Slider
            min={0}
            max={100}
            value={allocation[key]}
            onChange={(value) => handleAllocationChange(key, value)}
            orientation="horizontal"
            color={assetClass.colorName}
            label={createLabel(assetClass.name, assetClass.altName)}
          />
        </div>
      );
    });
  };

  return (
    <div className="ProfileBuilder">
      <div className='SliderBuilder__backgroup'>
        {renderSliders()}
      </div>
    </div>
  );
};

export default ProfileBuilder;
